import React, { Component, Suspense } from "react";
import "./styles/cards.scss";
import { searchBy } from "./search";
import axios from "axios";
import Select from "react-select";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { DatePicker } from "antd";
import { Services } from "../../Tracking/Services";
// import Button from '@material-ui/core/Button';

import {
  Container,
  Col,
  Row,
  InputGroupAddon,
  CardBody,
  InputGroupText,
  Input,
  InputGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";
import { saveAs } from "file-saver";
import IMG from "../../../../resources/filter.png";
const { RangePicker } = DatePicker;
const CardData = React.lazy(() => import("./card"));

class Cards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isOpen: false,
      loaderExcel: false,
      cards: "",
      search: "",
      toggleDrawer: this.props.toggleDrawer,
      resetCards: this.props.reset,
      labelStatus: this.props.labelStatus,
      dataSearch: [],
      activePage: 1,
      totalPages: 0,
      infoCard: false,
      advancedSearchData: this.props.advancedSearchData
        ? this.props.advancedSearchData
        : [],
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.data)
      this.setState({
        data: nextProps.data,
        dataSearch: nextProps.data,
        allMyData: nextProps.data,
      });
    if (nextProps.labelStatus)
      this.setState({ labelStatus: nextProps.labelStatus }, () => {
        this.buildCards();
        try {
          let selectedFileDoom = document.getElementById(nextProps.labelStatus);
          selectedFileDoom.classList.add("_cardSelected");
        } catch (e) { }
      });
  };

  buildCards = () => {
    let { data } = this.state;
    let tags = data.map((e, index) => {
      return (
        <div key={index} onClick={this.props.toggleDrawer(e)}>
          <Suspense fallback={<div>Loading...</div>}>
            <CardData
              infoCard={this.state.infoCard}
              key={index}
              config={this.props.config}
              data={e}
              element={e}
            ></CardData>
          </Suspense>
        </div>
      );
    });
    this.setState({
      cards: tags,
    });
  };

  handleChange = (name) => (event) => {
    if (this.props.newSearch) {
      this.props.newSearch(event.target.value);
    } else {
      let { allMyData } = this.state;
      this.setState(
        {
          [name]: event.target.value,
        },
        () => {
          if (this.state.search === "") {
            this.setState(
              {
                dataSearch: allMyData,
              },
              () => this.initPages()
            );
          } else {
            let results = searchBy(
              this.state.search,
              allMyData,
              this.props.config
            );
            this.setState(
              {
                dataSearch: results,
              },
              () => this.initPages()
            );
          }
        }
      );
    }
  };

  changePage = (page) => {
    this.setState(
      {
        activePage: page,
      },
      () => {
        this.buildPageResults();
      }
    );
  };

  handlAdvancedSearch = (search) => {
    this.props.backRes(search);
    this.setState({ isOpen: false });
  };

  toggleModal = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handleSearchChange = (e, i) => {
    this.setState({ search: i.value });
  };

  splitArray = (list, howMany) => {
    var idx = 0;
    var result = [];

    while (idx < list.length) {
      if (idx % howMany === 0) result.push([]);
      result[result.length - 1].push(list[idx++]);
    }
    return result;
  };

  callGenerate = (objPost) => {
    fetch(`${Services.generate_xls.path}`, objPost)
      .then(data => {
        return data.json();
      })
      .then((success) => {
        if (success.base64) {
          const fileName =
            Math.floor(Math.random() * 900000) +
            100000 +
            Math.floor(Date.now() / 1000) +
            ".xlsx";
          const linkSource = `data:application/xlsx;base64,${success.base64}`;
          saveAs(linkSource, fileName);
          this.setState({ loaderExcel: false });
        } else console.warn("Error downloading file", success);
      })
      .catch((error) => {
        console.error("errorr", error);
        this.setState({ loaderExcel: false });
      });
    // }
  };

  generateExcel = () => {
    this.setState({ loaderExcel: true });
    let { data } = this.state;
    let headers = [];
    let keys = [];
    this.props.config.map((e) => {
      if (e.xls) {
        if (e.first) {
          headers.push("Embarque");
          keys.push("DoEmbarque");
          headers.push("Documento de Transporte");
          keys.push("HBL_HAWB");
        } else {
          if (e.titleId) {
            headers.push(e.titleId);
          } else {
            headers.push(e.title);
          }
          if (e.idExcel) {
            keys.push(e.idExcel);
          } else {
            keys.push(e.id);
          }
        }
      }
      return e;
    });
    if (this.props.urlReport) {
      axios
        .post(this.props.urlReport, this.props.paramsxml)
        .then((response) => {
          if (response.data.data) {
            if (response.data.data.length > 10000) {
              let obj = {
                headers: {
                  'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                  data: response.data.data.splice(0, 10000),
                  options: {
                    headers: headers,
                    keys: keys,
                    image: {
                      name: 'rrmagicvision',
                    },
                  }
                })
              };
              this.callGenerate(obj);
            } else {
              let obj = {
                headers: {
                  'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                  data: response.data.data,
                  options: {
                    headers: headers,
                    keys: keys,
                    image: {
                      name: 'rrmagicvision',
                    },
                  }
                })
              };
              this.callGenerate(obj);
            }
          }
        })
        .catch((error) => {
          console.error("errorr", error);
          this.setState({ loaderExcel: false });
        });
    } else {
      let obj = {
        data: data,
        headers: headers,
        keys: keys,
      };
      if (headers.length > 0) {
        axios
          .post("https://rrapireports.azurewebsites.net/reports/dynamic", obj)
          .then((success) => {
            if (success.data.base64) {
              const fileName =
                Math.floor(Math.random() * 900000) +
                100000 +
                Math.floor(Date.now() / 1000) +
                ".xlsx";
              const linkSource = `data:application/xlsx;base64,${success.data.base64}`;
              saveAs(linkSource, fileName);
              this.setState({ loaderExcel: false });
            } else console.warn("Error downloading file", success);
          })
          .catch((error) => {
            console.error("errorr", error);
            this.setState({ loaderExcel: false });
          });
      }
    }
  };

  toggle = (evt) => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  getAdvancedData = (e, index, firstIndex) => {
    return (
      <Row key={index}>
        {e.map((f, index1) => {
          return this.getFilterData(f, index1, index, firstIndex);
        })}
      </Row>
    );
  };

  resetData = () => {
    let newAdvanced = this.state.advancedSearchData;
    newAdvanced.map((e) => {
      e.data.map((f) => {
        f.map((g) => {
          if (g.type === "dateRange") {
            g.date = {
              init: "",
              end: "",
            };
          } else {
            g.value = "";
          }
          return g;
        });
        return f;
      });
      return e;
    });
    this.setState({ advancedSearchData: newAdvanced });
  };

  findAdvanced = () => {
    let obj = [];
    this.state.advancedSearchData.map((e) => {
      e.data.map((f) => {
        f.map((g) => {
          if (!g.undefined) {
            let newPush = {
              id: g.id,
              isDate: g.type === "dateRange" ? true : false,
              value:
                g.type === "dateRange"
                  ? g.date
                  : g.type === "select"
                    ? g.value
                      ? g.value.value
                      : ""
                    : g.value,
            };
            obj.push(newPush);
          }
          return g;
        });
        return f;
      });
      return e;
    });
    this.props.advancedSearch(obj);
    this.toggle();
  };

  getFilterData = (e, index, secondIndex, firstIndex) => {
    switch (e.type) {
      case "text":
        return (
          <div
            key={index}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label>
              {e.title} {e.undefined ? "!" : ""}
              <InputGroup>
                <Input
                  type="text"
                  value={e.value}
                  name={e.title}
                  onChange={(e) => {
                    let newAdvanced = this.state.advancedSearchData;
                    if (newAdvanced[firstIndex]) {
                      if (newAdvanced[firstIndex].data) {
                        if (newAdvanced[firstIndex].data[secondIndex]) {
                          if (
                            newAdvanced[firstIndex].data[secondIndex][index]
                          ) {
                            newAdvanced[firstIndex].data[secondIndex][
                              index
                            ].value = e.target.value;
                            this.setState({ advancedSearchData: newAdvanced });
                          }
                        }
                      }
                    }
                  }}
                />
              </InputGroup>
            </label>
          </div>
        );
      case "select":
        return (
          <div
            key={index}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label>
              {e.title} {e.undefined ? "!" : ""}
              <Select
                placeholder=""
                isClearable={true}
                value={e.value}
                options={e.values}
                onChange={(value) => {
                  let newAdvanced = this.state.advancedSearchData;
                  if (newAdvanced[firstIndex]) {
                    if (newAdvanced[firstIndex].data) {
                      if (newAdvanced[firstIndex].data[secondIndex]) {
                        if (newAdvanced[firstIndex].data[secondIndex][index]) {
                          newAdvanced[firstIndex].data[secondIndex][
                            index
                          ].value = value;
                          this.setState({ advancedSearchData: newAdvanced });
                        }
                      }
                    }
                  }
                }}
              />
            </label>
          </div>
        );
      case "date":
        return (
          <div
            key={index}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label>
              {e.title} {e.undefined ? "!" : ""}
              <InputGroup>
                <Input
                  type="date"
                  name={e.title}
                  onChange={(e) => {
                    let newAdvanced = this.state.advancedSearchData;
                    if (newAdvanced[firstIndex]) {
                      if (newAdvanced[firstIndex].data) {
                        if (newAdvanced[firstIndex].data[secondIndex]) {
                          if (
                            newAdvanced[firstIndex].data[secondIndex][index]
                          ) {
                            newAdvanced[firstIndex].data[secondIndex][
                              index
                            ].value = e.target.value;
                            this.setState({ advancedSearchData: newAdvanced });
                          }
                        }
                      }
                    }
                  }}
                />
              </InputGroup>
            </label>
          </div>
        );

      // case "dateRange":
      //   return (
      //     <div
      //       key={index}
      //       className={e.class}
      //       style={{ marginTop: 5, marginBottom: 5 }}
      //     >
      //       <center>
      //         {e.title} {e.undefined ? "!" : ""}
      //       </center>
      //       <div className="row">
      //         <div className="col-6">
      //           <label>
      //             Start
      //             <InputGroup>
      //               <Datetime
      //                 timeFormat={false}
      //                 value={e.date.init}
      //                 inputProps={{ placeholder: "Start Date" }}
      //                 // name={e.title}
      //                 onChange={(e) => {
      //                   let newAdvanced = this.state.advancedSearchData;
      //                   if (newAdvanced[firstIndex]) {
      //                     if (newAdvanced[firstIndex].data) {
      //                       if (newAdvanced[firstIndex].data[secondIndex]) {
      //                         if (
      //                           newAdvanced[firstIndex].data[secondIndex][index]
      //                         ) {
      //                           newAdvanced[firstIndex].data[secondIndex][
      //                             index
      //                           ].date.init = moment(e._d).format("YYYY-MM-DD");
      //                           this.setState({
      //                             advancedSearchData: newAdvanced,
      //                           });
      //                         }
      //                       }
      //                     }
      //                   }
      //                 }}
      //               />
      //               {/* <Input
      //                   type="date"
      //                   value={e.date.init}
      //                   placeholder=" "
      //                   name={e.title}
      //                   onChange={(e) => {
      //                     let newAdvanced = this.state.advancedSearchData;
      //                     if (newAdvanced[firstIndex]) {
      //                       if (newAdvanced[firstIndex].data) {
      //                         if (newAdvanced[firstIndex].data[secondIndex]) {
      //                           if (
      //                             newAdvanced[firstIndex].data[secondIndex][index]
      //                           ) {
      //                             newAdvanced[firstIndex].data[secondIndex][
      //                               index
      //                             ].date.init = e.target.value;
      //                             this.setState({
      //                               advancedSearchData: newAdvanced,
      //                             });
      //                           }
      //                         }
      //                       }
      //                     }
      //                   }}
      //                 /> */}
      //             </InputGroup>
      //           </label>
      //         </div>
      //         <div className="col-6">
      //           <label>
      //             End
      //             <InputGroup>
      //               <Datetime
      //                 timeFormat={false}
      //                 value={e.date.end}
      //                 inputProps={{ placeholder: "End Date" }}
      //                 // name={e.title}
      //                 onChange={(e) => {
      //                   // console.log(
      //                   //   "e-------------->",
      //                   //   moment(e._d).format("YYYY-MM-DD")
      //                   // );
      //                   let newAdvanced = this.state.advancedSearchData;
      //                   if (newAdvanced[firstIndex]) {
      //                     if (newAdvanced[firstIndex].data) {
      //                       if (newAdvanced[firstIndex].data[secondIndex]) {
      //                         if (
      //                           newAdvanced[firstIndex].data[secondIndex][index]
      //                         ) {
      //                           newAdvanced[firstIndex].data[secondIndex][
      //                             index
      //                           ].date.end = moment(e._d).format("YYYY-MM-DD");
      //                           this.setState({
      //                             advancedSearchData: newAdvanced,
      //                           });
      //                         }
      //                       }
      //                     }
      //                   }
      //                 }}
      //               />
      //               {/* <Input
      //                   type="date"
      //                   value={e.date.end}
      //                   placeholder=" "
      //                   name={e.title}
      //                   onChange={(e) => {
      //                     console.log('e-------------->',e.target.value);

      //                     let newAdvanced = this.state.advancedSearchData;
      //                     if (newAdvanced[firstIndex]) {
      //                       if (newAdvanced[firstIndex].data) {
      //                         if (newAdvanced[firstIndex].data[secondIndex]) {
      //                           if (
      //                             newAdvanced[firstIndex].data[secondIndex][index]
      //                           ) {
      //                             newAdvanced[firstIndex].data[secondIndex][
      //                               index
      //                             ].date.end = e.target.value;
      //                             this.setState({
      //                               advancedSearchData: newAdvanced,
      //                             });
      //                           }
      //                         }
      //                       }
      //                     }
      //                   }}
      //                 /> */}
      //             </InputGroup>
      //           </label>
      //         </div>
      //       </div>
      //     </div>
      //   );
      // default:
      //   return (
      //     <div
      //       key={index}
      //       className={e.class}
      //       style={{ marginTop: 5, marginBottom: 5 }}
      //     >
      //       <label>
      //         {e.title} {e.undefined ? "!" : ""}
      //         <InputGroup>
      //           <Input type="text" name={e.title} />
      //         </InputGroup>
      //       </label>
      //     </div>
      //   );
      case "dateRange":
        return (
          <div
            key={index}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            {/* <center> */}
            <label className="labelTitleAvancSearc">
              {e.title} {e.undefined ? "!" : ""}
            </label>
            {/* </center> */}
            {/* <div className="row"> */}

            {/* <div className="col-6"> */}
            <RangePicker
              // locale={locale}
              onChange={(event) => {

                let newAdvanced = this.state.advancedSearchData;

                if (event === null) {
                  if (newAdvanced[firstIndex]) {
                    if (newAdvanced[firstIndex].data) {
                      if (newAdvanced[firstIndex].data[secondIndex]) {
                        if (newAdvanced[firstIndex].data[secondIndex][index]) {
                          newAdvanced[firstIndex].data[secondIndex][
                            index
                          ].date.init = "";
                          newAdvanced[firstIndex].data[secondIndex][
                            index
                          ].date.end = "";
                          this.setState({
                            advancedSearchData: newAdvanced,
                            [e.id]: event,
                          });
                        }
                      }
                    }
                  }
                } else {
                  let init = event[0].format("YYYY-MM-DD");
                  let end = event[1].format("YYYY-MM-DD");
                  if (newAdvanced[firstIndex]) {
                    if (newAdvanced[firstIndex].data) {
                      if (newAdvanced[firstIndex].data[secondIndex]) {
                        if (newAdvanced[firstIndex].data[secondIndex][index]) {
                          newAdvanced[firstIndex].data[secondIndex][
                            index
                          ].date.init = init;
                          newAdvanced[firstIndex].data[secondIndex][
                            index
                          ].date.end = end;
                          this.setState({
                            advancedSearchData: newAdvanced,
                            [e.id]: event,
                          });
                        }
                      }
                    }
                  }
                }
              }}
              value={
                this.state[e.id] === undefined || this.state[e.id] === null
                  ? ""
                  : [
                    moment(new Date(this.state[e.id][0])),
                    moment(new Date(this.state[e.id][1])),
                  ]
              }
              style={{
                height: "2.6em",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
              }}
              size="large"
              className="col-md-12"
            />
            {/* </div> */}
            {/* <div className="col-6">
                    <label>
                      Inicio
                      <InputGroup>
                        <Input
                          type="date"
                          value={e.date.init}
                          placeholder=" "
                          name={e.title}
                          onChange={(e) => {
                            let newAdvanced = this.state.advancedSearchData;
                            if (newAdvanced[firstIndex]) {
                              if (newAdvanced[firstIndex].data) {
                                if (newAdvanced[firstIndex].data[secondIndex]) {
                                  if (
                                    newAdvanced[firstIndex].data[secondIndex][index]
                                  ) {
                                    newAdvanced[firstIndex].data[secondIndex][
                                      index
                                    ].date.init = e.target.value;
                                    this.setState({
                                      advancedSearchData: newAdvanced,
                                    });
                                  }
                                }
                              }
                            }
                          }}
                        />
                      </InputGroup>
                    </label>
                  </div>
                  <div className="col-6">
                    <label>
                      Fin
                      <InputGroup>
                        <Input
                          type="date"
                          value={e.date.end}
                          placeholder=" "
                          name={e.title}
                          onChange={(e) => {
                            let newAdvanced = this.state.advancedSearchData;
                            if (newAdvanced[firstIndex]) {
                              if (newAdvanced[firstIndex].data) {
                                if (newAdvanced[firstIndex].data[secondIndex]) {
                                  if (
                                    newAdvanced[firstIndex].data[secondIndex][index]
                                  ) {
                                    newAdvanced[firstIndex].data[secondIndex][
                                      index
                                    ].date.end = e.target.value;
                                    this.setState({
                                      advancedSearchData: newAdvanced,
                                    });
                                  }
                                }
                              }
                            }
                          }}
                        />
                      </InputGroup>
                    </label>
                  </div>  */}
            {/* </div> */}
          </div>
        );

      default:
        return (
          <div
            key={index}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {e.title} {e.undefined ? "!" : ""}

            </label>
            <InputGroup>
              <Input type="text" name={e.title} />
            </InputGroup>
          </div>
        );
    }
  };

  render() {
    let { loaderExcel } = this.state
    return (
      <div className="content">
        <CardBody style={{ padding: "15px 0px 15px 0px" }}>
          <Row>
            <Col md={4}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Search</InputGroupText>
                </InputGroupAddon>
                <Input onChange={this.handleChange("search")} />
              </InputGroup>
            </Col>
            <Col xs={8}>
              <Row>
                <Col md={2}>
                  <img
                    onClick={() => {
                      if (this.state.advancedSearchData.length > 1) {
                        this.setState({ isOpen: true });
                      }
                    }}
                    alt="img"
                    width={26}
                    height={26}
                    src={IMG}
                    style={{ cursor: "pointer" }}
                  ></img>
                </Col>
                <Col md={10} style={{ textAlign: "end" }}>
                  <i
                    className={loaderExcel ? `big spinner loading icon custom-icon-xls` : `fas fa-file-excel fa-2x custom-icon-xls`}
                    disabled={loaderExcel}
                    onClick={() => { this.generateExcel() }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
        <CardBody style={{ padding: "0px 0px 0px 0px" }}>
          <Row>
            <Col sm={12}>{this.state.cards}</Col>
            <Modal isOpen={this.state.isOpen} toggle={this.toggle} size="lg" scrollable>
              <ModalHeader
                className="advancedSearchModal"
                style={{ background: "#005e97", color: "white" }}
                toggle={this.toggle}
              >
                <b>Advanced Search</b>
              </ModalHeader>
              <ModalBody>
                {this.state.advancedSearchData.map((f, index1) => {
                  return (
                    <Container
                      key={index1}
                      style={{ marginTop: 5, marginBottom: 5 }}
                    >
                      <Row>
                        <Col style={{ fontWeight: "bold" }}>
                          <center>{f.title ? f.title : `${"\u00A0"}`}</center>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {f.data.map((h, index2) => {
                            return this.getAdvancedData(h, index2, index1);
                          })}
                        </Col>
                      </Row>
                      {index1 !== this.state.advancedSearchData.length - 1 ? (
                        <div
                          style={{
                            background: "#f0f0f0",
                            height: 1,
                            marginTop: 10,
                            marginBottom: 10,
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </Container>
                  );
                })}
              </ModalBody>
              <ModalFooter className="modalFooterCenter">
                <center>
                  <Button
                    color="primary"
                    onClick={() => {
                      this.findAdvanced();
                    }}
                  >
                    Search
                  </Button>{" "}
                  {
                    // <Button color="secondary" onClick={() =>{this.resetData();}}>Reset</Button>{' '}
                  }
                  <Button outline color="danger" onClick={this.toggle}>
                    Cancel
                  </Button>
                </center>
              </ModalFooter>
            </Modal>
          </Row>
        </CardBody>
      </div>
    );
  }
}
export default Cards;
